import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=7f99e27e&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f99e27e",
  null
  
)

export default component.exports